/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_AccountInputs */

const en_settings_account = /** @type {(inputs: Settings_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account`)
};

const de_settings_account = /** @type {(inputs: Settings_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto`)
};

/**
* | output |
* | --- |
* | "Account" |
*
* @param {Settings_AccountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const settings_account = /** @type {((inputs?: Settings_AccountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_AccountInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_account(inputs)
	return en_settings_account(inputs)
});